import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

/**
 *# Only to be used with ReduxForm's Field
 */
export default function CustomDatePickerV2({ format = "DD-MM-YYYY", input, children, meta: { touched, error, warning }, ...props }) {
  return (
    <>
      <DatePicker name={input.name} style={{ width: "100%" }} value={moment.isMoment(input.value) ? input.value : undefined} format={format} onChange={input.onChange} {...props}>
        {children}
      </DatePicker>
      {touched &&
        ((error && <span className="error-input">{error}</span>) ||
          (warning && <span>{warning}</span>))}
    </>
  )
}
